import { AccountInfo } from '@azure/msal-browser';

export const MsalConfig: {
  isEnabled: boolean;
  redirectUri: string;
  authority: string;
  clientId: string;
  account: AccountInfo | null;
  msGraphScopes: string[];
  loginRequest: { scopes: string[] };
  tokenRequest: { scopes: string[] };
  authSchema: string;
  cmApiRequest: string[];
} = {
  isEnabled: false,
  redirectUri: 'https://' + window.location.hostname,
  authority: '',
  clientId: '',
  account: null,
  msGraphScopes: ['user.read', 'profile', 'openid', 'offline_access'],
  loginRequest: {
    scopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  },
  tokenRequest: {
    scopes: ['User.Read'],
  },
  authSchema: '',
  cmApiRequest: [''],
};
